import React from "react"
import { RouteComponentProps } from "react-router-dom";
import ApparecchioCategoriesStore from "../apparecchioCategoriesStore";
import { Loading } from "../../common/components/loading";
import { ApparecchioCategory, ApparecchioFamily } from "../../generated";
import { Link } from "../../common/components/link";
import { links } from "../../routes";
import ApparecchioTypeIcon from "./apparecchioTypeIcon";
interface Props extends RouteComponentProps<{ idCliente: string }> {

}

const ApparecchioTypeSelector = (props: { idCliente: number, type: ApparecchioCategory }) => {
    const { idCliente, type } = props;
    return <div className="card shadow-sm text-center" style={{ width: 200 }}>
        <div className="card-body d-flex flex-column align-items-center">
            <ApparecchioTypeIcon apparecchioType={type.id} height={50} width={50} className="mb-3" />
            <Link className="stretched-link"
                to={type.family == ApparecchioFamily.ClimatizzazioneElettrico
                    ? links.impiantoClimaNew(idCliente, type.id)
                    : links.impiantoNew(idCliente, type.id)}
            />
            <span className="fw-bold text-uppercase">{type.name}</span>
        </div>
    </div>
}

export default (props: Props) => {
    const apparecchiCategories = ApparecchioCategoriesStore.useAll();
    if (apparecchiCategories == null) return <Loading />

    const idCliente = parseInt(props.match.params.idCliente);
    return <div className="p-4">
        <h2 className="mb-3 text-theme fw-bold">Idrotermico</h2>
        <div className="d-flex align-items-center flex-wrap justify-content-center justify-content-lg-start" style={{ gap: 10 }}>
            {apparecchiCategories
                .filter(x => x.family == ApparecchioFamily.Idrotermico)
                .map(x => <ApparecchioTypeSelector key={x.id} type={x} idCliente={idCliente} />)}
        </div>
        <h2 className="mb-3 text-theme fw-bold">Biomassa</h2>
        <div className="d-flex align-items-center flex-wrap justify-content-center justify-content-lg-start" style={{ gap: 10 }}>
            {apparecchiCategories
                .filter(x => x.family == ApparecchioFamily.Biomassa)
                .map(x => <ApparecchioTypeSelector key={x.id} type={x} idCliente={idCliente} />)}
        </div>
        <h2 className="mb-3 text-theme fw-bold">Clima</h2>
        <div className="alert alert-info fw-bolder">NEW! Prova le nuove tipologie di impianto in anteprima!</div>
        <div className="d-flex align-items-center flex-wrap justify-content-center justify-content-lg-start" style={{ gap: 10 }}>
            {apparecchiCategories
                .filter(x => x.family == ApparecchioFamily.ClimatizzazioneElettrico)
                .map(x => <ApparecchioTypeSelector key={x.id} type={x} idCliente={idCliente} />)}
        </div>
    </div>
}